import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  openChatPopupAction, addMessagesAction, updateChatParamsAction, spliceMessagesAction, setMessagesAction,
} from './actions';

export const useChat = (roomId) => {
  const dispatch = useDispatch();
  const { [roomId]: chat } = useSelector((state) => state.chat);

  const openChatPopup = useCallback((params) => {
    dispatch(openChatPopupAction({ ...params, roomId }));
  }, [dispatch, roomId]);

  const updateChat = useCallback((data) => {
    dispatch(updateChatParamsAction({ roomId, data }));
  }, [dispatch, roomId]);

  const setMessages = useCallback((data) => {
    dispatch(setMessagesAction({ roomId, data }));
  }, [dispatch, roomId]);

  const addMessages = useCallback((data) => {
    dispatch(addMessagesAction({ roomId, data }));
  }, [dispatch, roomId]);

  const spliceMessages = useCallback((data) => {
    dispatch(spliceMessagesAction({ roomId, data }));
  }, [dispatch, roomId]);

  return {
    chat, updateChat, openChatPopup, addMessages, spliceMessages, setMessages,
  };
};
